/* eslint-disable unicorn/no-null */

import type { FC } from 'react';
import { Box, Text, TextInput } from '@mantine/core';
import { cn } from '@/utils';

interface FileTreeInlineRenameProps {
    defaultValue: string;
    error?: string;
    inputRef: React.RefObject<HTMLInputElement | null>;
    handleCancel: () => void;
    handleSubmit: (value: string) => void;
}

export const FileTreeInlineRename: FC<FileTreeInlineRenameProps> = ({
    defaultValue,
    error,
    handleCancel,
    handleSubmit,
    inputRef
}) => (
    <Box className="flex-1">
        <TextInput
            aria-invalid={Boolean(error)}
            classNames={{
                input: cn(
                    'h-6 min-h-6 w-full rounded border bg-white px-1 text-xs outline-none',
                    error
                        ? 'border-red-5 focus:border-red-6'
                        : 'border-blue-5 focus:border-blue-6'
                )
            }}
            defaultValue={defaultValue}
            ref={inputRef}
            size="xs"
            variant="unstyled"
            onBlur={(event) => {
                handleSubmit(event.currentTarget.value);
            }}
            onClick={(event) => {
                event.stopPropagation();
            }}
            onKeyDown={(event) => {
                if (event.key === 'Enter') {
                    event.preventDefault();
                    handleSubmit(event.currentTarget.value);
                    return;
                }
                if (event.key === 'Escape') {
                    event.preventDefault();
                    handleCancel();
                }
            }}
        />
        {error ? (
            <Text c="red.6" size="xs">
                {error}
            </Text>
        ) : null}
    </Box>
);
